import angular from "angular";

angular.module('ui-sentinel.calibrations', [
    'ui-sentinel.calibrations.calibrationControlCenter'
]);
